export default function formatDate(date: Date) {
  const newDate = new Date(date);

  const day = newDate.toLocaleDateString(['ban', 'id'], {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });

  return `${day}`;
}
